var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('information-content',{on:{"redirect":_vm.redirectHome}},[_c('template',{slot:"title"},[_vm._v("\n        La ressource que vous demandez n'est pas accessible,\n    ")]),_vm._v(" "),_c('template',{slot:"label"},[_vm._v("\n        RETOUR VERS L'ACCUEIL\n    ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01e5cb94","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/response/Code404.vue
// module id = null
// module chunks = 